import { Component, Input, computed, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { ModalContentData } from '../modal-content';
import { SignalsStoreService } from '../../signals-store.service';
import { OrderService } from '../../order.service';
import { handleImageError } from '../../common/utils';
import { formatDateToReadableString } from '../../utils/formatting';

@Component({
  selector: 'app-welcome-message',
  imports: [],
  templateUrl: './welcome-message.component.html',
  styleUrl: './welcome-message.component.scss'
})
export class WelcomeMessageComponent {

  private signalsStoreService = inject(SignalsStoreService);
  #orderService = inject(OrderService);

  activeModal = inject(NgbActiveModal);
  router = inject(Router);

  isInShopComponent = computed(() => this.signalsStoreService.getIsInShopComponent());

  subscription = computed(() => this.#setupSubscription());

  errorImage = handleImageError;

  @Input() modalContentData!: ModalContentData;

  deliveryInfo = computed(() => this.#setupDeliveryInfo());

  goTo() {
    if (!this.isInShopComponent())
      this.router.navigate([`/shop`]);
    this.close()
  }

  close() {
    this.activeModal.close();
  }

  #setupSubscription() {
    const order = this.#orderService.odooOrder();
    if (!order) return null;
    if (!order?.products) {
      this.close()
      return null
    };
    const { products } = order;
    if (!products?.subscription?.length) {
      this.close()
      return null
    };
    const { subscription } = products;
    const bundle = subscription.find((s: any) => s.isBundle === true);
    if (!bundle) {
      this.close()
      return null
    };
    const formatter = new Intl.ListFormat('en', { style: 'long', type: 'conjunction' });
    const items = bundle.bundle?.items?.map((e: { name: any; }) => e.name) || []
    return {
      img: bundle.img,
      name: bundle.name,
      items: formatter.format(items)
    };
  }

  #setupDeliveryInfo() {
    const data = this.modalContentData?.welcomeMessage?.deliveryDate || null;
    if (!data) return '';
    const formatted = formatDateToReadableString(data)

    return formatted.mmddyyyyFormat
  }
}
